<stx-generic-page>
  <stx-report-header>
    {{ 'reports.qa_ortho_cases' | translate }}
  </stx-report-header>
  <stx-report-filters [reportConfig]="reportConfig" (applyFilters)="applyFilters($event)"></stx-report-filters>

  @if (reportService.filtersReady$ | async) {
  <stx-qa-ortho-cases-report-table></stx-qa-ortho-cases-report-table>
  }
</stx-generic-page>
